import './replace-product-screen-content.scss';
import { ProductList, useProductByCustomerList } from '../../../product';
import {
  AddLineItems,
  CategoryTreeItem,
  getExtraDetails,
  ProductCardVariant,
  ProductVariant,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { OrderProductActionType } from '../../../constants';

interface ReplaceProductScreenContentProps {
  onClose?: () => void;
  lineItems?: AddLineItems[];
  onReplaceProduct?: (product: ProductVariant) => void;
}

export const ReplaceProductScreenContent: React.FC<
  ReplaceProductScreenContentProps
> = ({ onClose, lineItems, onReplaceProduct }) => {
  const orderInfo = useAppSelector(getExtraDetails);

  const {
    productsData,
    lastItemRef,
    onAddProductPress,
    onReplaceProductPress,
    onProductRemoveAndUpdate,
    categoryTree,
    setSelectedCategories,
    total,
    searchKey,
    onScroll,
    isLoading,
    setShowFilter,
    showFilter,
    segmentFilters,
    setSelectedSegment,
    isEndOfList,
    refreshProducts,
  } = useProductByCustomerList({
    onReplaceSuccess: onClose,
  });

  return (
    <div className="replace-product-screen-content">
      <ProductList
        data={productsData}
        lastItemRef={lastItemRef}
        onScroll={onScroll}
        variant={orderInfo?.variantType as ProductCardVariant}
        total={total}
        searchKey={searchKey as string}
        onAddProductPress={onAddProductPress}
        onProductRemoveAndUpdate={(item, type) =>
          onProductRemoveAndUpdate(item, type as OrderProductActionType)
        }
        onReplaceProductPress={(pv) => {
          if (onReplaceProduct) onReplaceProduct(pv);
          else onReplaceProductPress(pv);
        }}
        isLoading={isLoading}
        setShowFilter={setShowFilter}
        showFilter={showFilter}
        isEndOfList={isEndOfList}
        segments={segmentFilters}
        categories={categoryTree as CategoryTreeItem}
        updateSelectedCategories={setSelectedCategories}
        updateSelectedSegments={setSelectedSegment}
        onRefresh={refreshProducts}
        lineItems={lineItems}
        isByCustomer
      />
    </div>
  );
};
